(function () {
  
  // ─── Helpers ─────────────────────────────────────────
  const qs  = (el, sel) => el.querySelector(sel);
  const qsa = (el, sel) => el.querySelectorAll(sel);

  // ─── Cart Fetch (shared) ─────────────────────────────
  async function getCart() {
    if (window.productCart) return window.productCart.fetchCart();
    return fetch('/cart.js').then(r => r.json()).catch(() => ({ items: [] }));
  }

  function getActiveVariantId(card) {
    return parseInt(qs(card, '.product-actions_wrapper')?.dataset.variantId);
  }

  function setActiveVariantId(card, variantId) {
    const wrapper = qs(card, '.product-actions_wrapper');
    if (wrapper) wrapper.dataset.variantId = variantId;
  }

  // ─── UI Update ───────────────────────────────────────
  function updateUI(card, { inventoryQty, inCart, variant, button }) {
    const v_url            = qs(card, '.hh-product-card__header--wrapper');
    const cardImage        = qs(card, '.hh-product-card__media--wrapper img');
    const cardTitle        = qs(card, '.hh-product-card__product-title');
    const cardPrice        = qs(card, '.hh-product-card__body--price-wrapper');
    const modalOpener      = qs(card, '.hh-product-color-selector_container');
    const quantitySelector = qs(card, '.quantity-selector_quantitySelector');
    const addToBag         = qs(card, '.product-addToBag__action');
    const addToBagBtn      = qs(addToBag, 'button');
    const qtyInput         = qs(quantitySelector, 'input');
    if (inventoryQty === 0) {
      quantitySelector.style.display = "none";
      addToBag.style.display         = "flex";
      addToBagBtn.classList.add("product-actions_primary__soldOut");
      addToBagBtn.disabled           = true;
      addToBagBtn.textContent        = "Sold Out";

    } else if (inCart > 0) {
      quantitySelector.style.display = "flex";
      qtyInput.value                 = inCart;
      qtyInput.max                   = inventoryQty;
      addToBag.style.display         = "none";
      addToBagBtn.classList.remove("product-actions_primary__soldOut");
      addToBagBtn.disabled           = false;
      addToBagBtn.textContent        = "Add to Bag";

    } else {
      quantitySelector.style.display = "none";
      addToBag.style.display         = "flex";
      addToBagBtn.classList.remove("product-actions_primary__soldOut");
      addToBagBtn.disabled           = false;
      addToBagBtn.textContent        = "Add to Bag";
    }

    setActiveVariantId(card, variant.id);

    if (window.productCart) {
      window.productCart.maxInventoryMap[variant.id] = inventoryQty;
    }
    v_url.href = `${v_url.href}?variant=${variant.id}`;
    if (variant.featured_image) cardImage.src = variant.featured_image.src;
    if (variant.name)           cardTitle.textContent = variant.name;
    cardPrice.textContent = `Rs.${(variant.price / 100).toLocaleString()}`;

    if (button) {
      qs(modalOpener, 'img').src =
        qs(button, '.hh-product-colors-dialog_imageContainer img').src;

      qs(modalOpener, '.hh-product-color-selector_name').textContent =
        variant.title;
    }
  }

  // ─── Initial State ───────────────────────────────────
  function initCardState(card, cart) {
    const variantId = getActiveVariantId(card);
    if (!variantId) return;

    const inventoryQty = parseInt(
      qs(card, '.quantity-selector_quantityInput__ZG_I4')?.getAttribute('max')
    ) || 0;

    const cartItem = cart.items.find(item => item.variant_id === variantId);
    const inCart   = cartItem?.quantity ?? 0;

    const quantitySelector = qs(card, '.quantity-selector_quantitySelector');
    const addToBag         = qs(card, '.product-addToBag__action');
    const addToBagBtn      = qs(addToBag, 'button');
    const qtyInput         = qs(quantitySelector, 'input');

    if (inventoryQty === 0) {
      quantitySelector.style.display = "none";
      addToBag.style.display         = "flex";
      addToBagBtn.disabled           = true;
      addToBagBtn.textContent        = "Sold Out";
      addToBagBtn.classList.add("product-actions_primary__soldOut");

    } else if (inCart > 0) {
      quantitySelector.style.display = "flex";
      qtyInput.value                 = inCart;
      qtyInput.max                   = inventoryQty;
      addToBag.style.display         = "none";
    }
  }

  // ─── Card Init (SAFE) ────────────────────────────────
  function initProductCard(card) {
    // ✅ prevent duplicate listeners
    if (card.dataset.initialized === "true") return;
    card.dataset.initialized = "true";

    const modalOpener  = qs(card, '.hh-product-color-selector_container');
    const modal        = qs(card, '.hh-product-title_actionsPaneContainer');
    const modalCloser  = qs(card, '.hh-product-title_actionsPaneButton');
    const colorButtons = qsa(card, '.hh-product-colors-dialog_color');

    if (!modal) return;

    modalOpener?.addEventListener('click', () => {
      modal.style.display = "flex";
    });

    modalCloser?.addEventListener('click', () => {
      modal.style.display = "none";
    });

    colorButtons.forEach(button => {
      button.addEventListener('click', async () => {
        const variantId    = parseInt(button.dataset.id);
        const inventoryQty = parseInt(
          button.getAttribute('data-inventory-quantity')
        ) || 0;

        try {
          const [variantRes, cart] = await Promise.all([
            fetch(`/variants/${variantId}.js`).then(r => r.json()),
            getCart()
          ]);

          const cartItem = cart.items.find(
            item => item.variant_id === variantId
          );

          const inCart = cartItem?.quantity ?? 0;
          
          updateUI(card, {
            inventoryQty,
            inCart,
            variant: variantRes,
            button
          });
          syncXbWishlist(card, variantId, variantRes);
        } catch (err) {
          console.error('Variant error:', err);
        } finally {
          modal.style.display = "none";
        }
      });
    });
  }

  // ─── Main Init ───────────────────────────────────────
  async function initAllCards() {
    console.log("initProductCards called ✅");

    const cards = qsa(document, '.hh-product-card');
    if (!cards.length) return;

    cards.forEach(card => initProductCard(card));

    try {
      const cart = await getCart();
      cards.forEach(card => initCardState(card, cart));
    } catch (err) {
      console.error('initAllCards error:', err);
    }
  }

  // ─── sync Xb Wish list ───────────────────────────────────────
  function syncXbWishlist(card, variantId, variantRes) {
    // 1. Login check
    const isLoggedIn = localStorage.getItem('xb_wishlist_login_user') === 'true';
    if (!isLoggedIn) return;

    // 2. Wishlist mein hai ya nahi check karo
    let wishlistData = [];
    try {
      wishlistData = JSON.parse(localStorage.getItem('xb_wishlist_data') || '[]');
    } catch (e) {
      wishlistData = [];
    }

    const isWishlisted = wishlistData.some(
      item => String(item.variantId) === String(variantId)
    );
    // 3. Card ke andar xb-wishlist-button dhundo
    const xbBtn = card.querySelector('xb-wishlist-button');
    if (!xbBtn) return;
    // 4. Attributes update karo
    console.log(variantRes);
    
    xbBtn.setAttribute('xb-variant-id', variantId);
    xbBtn.setAttribute('xb-title', variantRes.name || variantRes.title || '');
    xbBtn.setAttribute('xb-price', variantRes.price || '');
    
    const btn = xbBtn.querySelector('button');
    if (!btn) return;

    // aria label
    btn.setAttribute(
      'aria-label',
      isWishlisted ? 'Remove from wishlist' : 'Add to wishlist'
    );

    // button class
    btn.classList.toggle('xb-wishlist-button__add-style', !isWishlisted);
    btn.classList.toggle('xb-wishlist-button__remove-style', isWishlisted);

    // icon wrapper
    const iconWrapper = btn.querySelector('[class*="icon-style"]');

    if (iconWrapper) {
      iconWrapper.classList.remove(
        'xb-wishlist-button__add-icon-style',
        'xb-wishlist-button__remove-icon-style'
      );

      iconWrapper.classList.add(
        isWishlisted
          ? 'xb-wishlist-button__remove-icon-style'
          : 'xb-wishlist-button__add-icon-style'
      );
    }

    // outline icon
    const outline = btn.querySelector('[class*="icon-outline"]');
    if (outline) {
      outline.className = isWishlisted
        ? 'xb-wishlist-button__remove-icon-outline'
        : 'xb-wishlist-button__add-icon-outline';
    }

    // fill icon
    const fill = btn.querySelector('[class*="icon-fill"]');
    if (fill) {
      fill.className = isWishlisted
        ? 'xb-wishlist-button__remove-icon-fill'
        : 'xb-wishlist-button__add-icon-fill';
    }
    // 5. Button state update karo
  }

  // ─── Expose globally ─────────────────────────────────
  window.initProductCards = initAllCards;
  
  // ─── Initial load ────────────────────────────────────
  document.addEventListener("DOMContentLoaded", function () {
    window.initProductCards();
  });

})();